module.exports = new __parcel__URL__("empoweredsoulessence.8bcc4151.png").toString();